import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Spinner, Alert } from "reactstrap";
import { useStaffStore } from "../../stores/Staffs";

const DeclineInvitation = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { verifyInvitationToken, declineInvitationToken } = useStaffStore();
  const [loading, setLoading] = useState(true);
  const [declining, setDeclining] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [invitationData, setInvitationData] = useState(null);

  useEffect(() => {
    const handleDeclineInvitation = async () => {
      try {
        setLoading(true);
        setError(null);

        // First verify the invitation token
        console.log("Verifying invitation token...");
        const inviteData = await verifyInvitationToken(token);

        // Check if invitation is still pending
        if (inviteData.status !== "PENDING") {
          setError("This invitation link is no longer valid. It may have already been accepted, declined, or expired.");
          setLoading(false);
          return;
        }

        setInvitationData(inviteData);

        // Now decline the invitation
        console.log("Declining invitation...");
        setDeclining(true);
        const response = await declineInvitationToken(token);

        setSuccess(true);
        setLoading(false);
        setDeclining(false);

      } catch (err) {
        console.error("Error declining invitation:", err);
        setError(err.message || "Failed to decline invitation. Please try again.");
        setLoading(false);
        setDeclining(false);
      }
    };

    if (token) {
      handleDeclineInvitation();
    } else {
      setError("Invalid invitation link");
      setLoading(false);
    }
  }, [token, verifyInvitationToken, declineInvitationToken]);

  const handleGoToLogin = () => {
    navigate("/login");
  };

  if (loading || declining) {
    return (
      <div className="auth-page">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5">
              <Card>
                <CardBody className="text-center p-5">
                  <Spinner color="warning" className="mb-3" />
                  <h5>{declining ? "Declining invitation..." : "Processing your response..."}</h5>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <Card>
              <CardHeader className="text-center">
                <CardTitle className="h4 mb-0 text-warning">
                  <i className="ri-close-circle-line me-2"></i>
                  Invitation Declined
                </CardTitle>
              </CardHeader>
              <CardBody>
                {success ? (
                  <>
                    <div className="text-center mb-4">
                      <div className="avatar-lg mx-auto mb-3">
                        <div className="avatar-title rounded-circle bg-warning-subtle text-warning">
                          <i className="ri-close-circle-line fs-24"></i>
                        </div>
                      </div>
                      <h5 className="text-warning">Invitation Declined</h5>
                      <p className="text-muted">
                        You have successfully declined the invitation from <strong>{invitationData?.site?.name}</strong>.
                        No further action is required.
                      </p>
                    </div>

                    <Alert color="info">
                      <i className="ri-information-line me-2"></i>
                      <strong>What's next?</strong> If you change your mind, you can contact the person
                      who invited you to request a new invitation.
                    </Alert>


                  </>
                ) : (
                  <Alert color="danger">
                    {error || "An error occurred while processing your request."}
                  </Alert>
                )}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeclineInvitation;

